import { Button, Input, Label } from "@web-app/components";
import ChecklistQuantity from "@web-app/pages/common/ChecklistQuantity";
import { ChecklistItem, FieldValue, Order } from "@web-app/types";

interface EditItemChecklistProps {
  checklistKey: "dropoffChecklist" | "pickupChecklist";
  debouncedHandleFieldChange: (property: string, value: FieldValue) => void;
  onFieldChange: (property: string, value: FieldValue) => unknown;
  order: Order;
}

export default function EditItemChecklist({
  checklistKey,
  debouncedHandleFieldChange,
  onFieldChange,
  order,
}: EditItemChecklistProps) {
  const checklist: ChecklistItem[] = order[checklistKey] ?? [];

  const updateItem = (index: number, changes: Partial<ChecklistItem>) => {
    const newList = [...checklist];
    newList[index] = { ...newList[index], ...changes };
    return newList;
  };

  return (
    <div className="flex flex-col gap-1">
      <Label>Checklist</Label>
      <div>
        {checklist.map((item, index) => (
          <div key={index} className="flex items-center gap-1.5 pb-1.5">
            <Input
              type="checkbox"
              value={item.isChecked ? "true" : "false"}
              onChange={(value: string) =>
                onFieldChange(
                  checklistKey,
                  updateItem(index, { isChecked: value === "true" }),
                )
              }
            />
            <Input
              type="text"
              size="xs"
              defaultValue={item.label}
              onChange={(value: string) =>
                debouncedHandleFieldChange(
                  checklistKey,
                  updateItem(index, { label: value }),
                )
              }
            />
            <ChecklistQuantity
              quantity={item.quantity}
              onChange={(quantity) =>
                onFieldChange(checklistKey, updateItem(index, { quantity }))
              }
            />
            <Button
              plain
              size="2xs"
              className="!p-1 text-gray-500"
              iconClassName="!h-2.5 !w-2.5"
              aria-label="Remove item"
              icon="fasTrash"
              onClick={() =>
                onFieldChange(
                  checklistKey,
                  checklist.filter((_, i) => i !== index),
                )
              }
            />
          </div>
        ))}
        <Button
          plain
          size="sm"
          onClick={() =>
            onFieldChange(checklistKey, [
              ...checklist,
              { isChecked: false, isMandatory: false, label: "" },
            ])
          }
        >
          + Add Item
        </Button>
      </div>
    </div>
  );
}
